import { render, staticRenderFns } from "./SelectedPropertyByClient.vue?vue&type=template&id=45d4a5ce&"
import script from "./SelectedPropertyByClient.vue?vue&type=script&lang=js&"
export * from "./SelectedPropertyByClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports